// src/components/PhotonLogo.jsx
import React from 'react';

const PhotonLogo = () => {
  return (
    <img src="/assets/images/logo.png" alt="Logo" style={{ width: '100px', height: 'auto' }} />
  );
};

export default PhotonLogo;
